export const EDIT_USER_ROLE_NAME = "edit_user_role";
export const EDIT_USER_ROLE_DESC = `Updates a workspace member role via GraphQL.

Use when the user asks to change a member's role in the current workspace.
In user-facing text, present role choices as Owner / Administrator / Editor / Viewer.

Input:
- 'email' (required): Target member email.
- 'role' (required): New role enum value. Assignable values are OWNER, ADMINISTRATOR, FULL_MEMBER, and GUEST.

Notes:
- Fails when the member is not found in the organization.
- Fails when the requested role is already assigned.
- Returns updated member metadata, localized role labels, and helper links ('organizationPath'/'organizationUrl').
- Write operation; requires confirmation before execution.`;
